import {
  Box,
  Button,
  Container,
  Divider,
  Hidden,
  List,
  ListItem,
  ListItemText,
  SwipeableDrawer,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import Modal from "../modal";
import Logout from "../logoutModal";
import { useWeb3React } from "@web3-react/core";

const useStyles = makeStyles({
  nav: {
    background:
      "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
    borderRadius: "40.5px",
    border: "1.6875px solid #EEBE62",
    fontSize: "18.56px",
    fontWeight: 400,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 10px 5px rgba(238, 190, 98, 0.12)",
    "&:hover": {
      boxShadow: "0 0 11px 4px #EEBE62",
    },
  },
  paper: {
    backgroundColor: "#000A19",
  },
});
function Header() {
  const classes = useStyles();
  const { account } = useWeb3React();
  const matches = useMediaQuery("(max-width:750px)");
  const [logout, setlogout] = useState(false);
  const [connect, setconnect] = useState(false);

  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["PDF Guide", "Audit"].map((text, index) => (
          <ListItem
            button
            key={text}
            style={{ color: "#ffffff", textAlign: "center" }}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      {account ? (
        <Box
          className={classes.nav}
          onClick={() => setlogout(true)}
          fontSize="14px"
          zIndex="100"
          color="text.secondary"
          width={matches ? "130px" : "181.41px"}
          height={matches ? "45px" : "52.31px"}
        >
          {account.slice(0, 6) + "..." + account.slice(-4)}
        </Box>
      ) : (
        <Box
          className={classes.nav}
          zIndex="100"
          fontSize="18px"
          color="text.secondary"
          width={matches ? "130px" : "181.41px"}
          height={matches ? "45px" : "52.31px"}
          onClick={() => setconnect(true)}
        >
          Connect
        </Box>
      )}
    </Box>
  );

  return (
    <Box>
      <Modal walletOpen={connect} setWalletOpen={setconnect} />
      <Logout openLogout={logout} setopenLogout={setlogout} />
      <Container maxWidth="lg">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={3}
        >
          <Box zIndex="100">
            <Link
              to="/"
              style={{
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              <img
                src={logo}
                width={matches ? "80px" : "100px"}
                alt="not found"
              />
            </Link>
          </Box>

          <Box display="flex" alignItems="center">
            <Hidden smDown>
              <Box display="flex" alignItems="center">
                <a
                  target="_blank"
                  style={{ textDecoration: "none" }}
                  href="./bnbshield.pdf"
                >
                  <Box
                    mr={2}
                    sx={{
                      textTransform: "capitalize",
                      color: "#FDFCFC",
                      fontSize: matches ? "17px" : "20px",
                      fontWeight: 400,
                    }}
                  >
                    PDF Guide
                  </Box>
                </a>
                <a
                  href="audit.pdf"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <Box
                    ml={2}
                    mr={5}
                    sx={{
                      textTransform: "capitalize",
                      color: "#FDFCFC",
                      fontSize: matches ? "17px" : "20px",
                      fontWeight: 400,
                    }}
                  >
                    AUDIT
                  </Box>
                </a>
              </Box>
            </Hidden>
            {account ? (
              <Box
                className={classes.nav}
                onClick={() => setlogout(true)}
                fontSize="16px"
                zIndex="100"
                color="text.secondary"
                width={matches ? "130px" : "181.41px"}
                height={matches ? "45px" : "52.31px"}
              >
                {account.slice(0, 6) + "..." + account.slice(-4)}
              </Box>
            ) : (
              <Box
                className={classes.nav}
                zIndex="100"
                fontSize="18px"
                color="text.secondary"
                width={matches ? "130px" : "181.41px"}
                height={matches ? "45px" : "52.31px"}
                onClick={() => setconnect(true)}
              >
                Connect
              </Box>
            )}
          </Box>

          <Hidden smUp>
            <Box>
              {["left"].map((anchor) => (
                <React.Fragment key={anchor}>
                  <Button onClick={toggleDrawer(anchor, true)}>
                    <MenuIcon style={{ color: "#ffffff", fontSize: "40px" }} />
                  </Button>
                  <SwipeableDrawer
                    classes={{ paper: classes.paper }}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                    onOpen={toggleDrawer(anchor, true)}
                  >
                    {list(anchor)}
                  </SwipeableDrawer>
                </React.Fragment>
              ))}
            </Box>
          </Hidden>
        </Box>
      </Container>
    </Box>
  );
}

export default Header;
